import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { setGeo } from './helpers';

export function clearGeo(jsonQuery: IJsonQuery): () => IJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
